import script from "./supporterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./supporterPage.vue?vue&type=script&setup=true&lang=js"

import "./supporterPage.vue?vue&type=style&index=0&id=bf224aa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf224aa4"]])

export default __exports__